import React from "react"

const NotifComponent = ({
  notifID, 
  headingText, 
  bodyText,
  setRunningNotifs,
  bgColor = "bg-blue-200",
  textColor = "text-blue-800",
  headingTextSize = "text-lg",
  bodyTextSize = "text-sm",
  className = "",
  ...props
}) => {

  const isFirstLoad = React.useRef(true);

  React.useEffect(() => {
    if (!isFirstLoad.current) return;
    isFirstLoad.current = false;

    setTimeout(() => {
      const notif = document.getElementById(notifID);

      // animate fade in
      notif.style.opacity = 1;
      notif.style.transform = "translateX(0)";

    }, 100);

    setTimeout(() => {
      const notif = document.getElementById(notifID);

      // animate fade out
      notif.style.opacity = 0;
      notif.style.transform = "translateX(8rem)";

      // animate height change
      setTimeout(() => {
        notif.style.height = "0px";
        notif.style.padding = "0px";
        notif.style.marginBottom = "0px";
      }, 250);

      // remove notif from runningNotifs
      setTimeout(() => {
        setRunningNotifs((prev) => {
          return prev.filter((notif) => {
            return notif.id !== notifID;
          });
        });
      }, 700);

    }, 5000);

  }, [notifID, setRunningNotifs]);

  return (
    <div
      id={notifID} 
      className={`opacity-0 mb-2 translate-x-8 flex flex-col w-[calc(100vw-2rem)] sm:w-[300px] px-4 py-2 rounded-xl shadow-[0_0_10px_rgba(0,0,0,0.3)] transition-all duration-200 ease-in-out ${bgColor} ${className}`}
    >
      <h1 className={`font-bold ${textColor} ${headingTextSize}`}>{headingText}</h1>
      <p className={`${textColor} ${bodyTextSize}`}>{bodyText}</p>
    </div>
  )
}

export function NotifWrapper({
  runningNotifs,
  setRunningNotifs,
   ...props 
}) {
  
  return (
    <>
      <div className="fixed top-[70px] right-0 m-4 z-[80]">
        <div className="flex flex-col">
          {runningNotifs?.map((notif, index) => {

            return (
              <NotifComponent
                key={notif.id}
                notifID={notif.id}
                headingText={notif.headingText}
                bodyText={notif.bodyText}
                bgColor={notif.bgColor}
                textColor={notif.textColor}
                headingTextSize={notif.headingTextSize}
                bodyTextSize={notif.bodyTextSize}
                className={notif.className}
                setRunningNotifs={setRunningNotifs}
              />
            )
          })}
        </div>
      </div>
    </>
  )
}